import Vue from 'vue'
import Router from 'vue-router'
import paths from './paths'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// initialize
Vue.use(Router)
const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
})
// router gards to check permission
router.beforeEach((to, from, next) => {
  NProgress.start()
  const authRequired = !to.meta.public
  const loggedIn = localStorage.getItem('token')

  if (authRequired && !loggedIn) {
   return next('/login')
  }
  next()
})

router.afterEach((to, from) => {
  // ...
  NProgress.done()
})

export default router
